import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import VduGatewayConfigurationFields from './VduGatewayConfigurationFields'

export const VduGatewayConfigurationEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props} />}>
      <Grid container spacing={8}>
        <VduGatewayConfigurationFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default VduGatewayConfigurationEdit
